import React, { forwardRef, useState, useImperativeHandle } from 'react';

const CustomDatetimePicker = forwardRef(({ value, title, onChange }, ref) => {
  const [dateTime, setDateTime] = useState(value ? formatDateForInput(value) : '');
  const [titleValue, setTitleValue] = useState(title || '');

  function formatDateForInput(date) {
    if (!(date instanceof Date)) {
      date = new Date(date);
    }
    return date.toLocaleString('sv-SE', { timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone }).slice(0, 16).replace(' ', 'T');
  }

  function parseInputToLocalDate(input) {
    if (!input) return null;
    return new Date(input);
  }

  const handleDateTimeChange = (event) => {
    const inputValue = event.target.value;
    setDateTime(inputValue);
    const newDateTime = parseInputToLocalDate(inputValue);
    onChange({ dateTime: newDateTime, title: titleValue });
  };

  const handleTitleChange = (event) => {
    const newTitle = event.target.value;
    setTitleValue(newTitle);
    onChange({ dateTime: parseInputToLocalDate(dateTime), title: newTitle });
  };

  useImperativeHandle(ref, () => ({
    get value() {
      return { dateTime: parseInputToLocalDate(dateTime), title: titleValue };
    },
    set value(newValue) {
      if (newValue && newValue.dateTime) {
        setDateTime(formatDateForInput(new Date(newValue.dateTime)));
      }
      if (newValue && newValue.title !== undefined) {
        setTitleValue(newValue.title);
      }
    }
  }));

  return (
    <div style={{
      width: '100%',
      marginLeft: 'auto',
      marginRight: 'auto',
      textAlign: 'center',
      border: '2px solid black',
      padding: '8px 12px'
    }}>
      <input
        type="datetime-local"
        value={dateTime}
        onChange={handleDateTimeChange}
      />
      <br />
      <input
        style={{
          width: '100%',
          marginLeft: 'auto',
          marginRight: 'auto',
          textAlign: 'center',
        }}
        type="text"
        value={titleValue}
        onChange={handleTitleChange}
        placeholder="Titulo"
      />
    </div>
  );
});

export default CustomDatetimePicker;
